import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import toDollars from 'utils/to-dollars';

// Global Types
import { AppState } from 'services/types';
import {
    MyTimesheetEntryEarnings,
    MyTimesheetEntriesProps
} from 'services/myTimesheetEntries/types';

// Global Selectors
import { makeSelectMyTimesheetEarnings } from 'services/myTimesheetEntries/selectors';

type OwnProps = MyTimesheetEntriesProps;

interface ConnectedProps {
    earnings?: MyTimesheetEntryEarnings;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntryEarningsValue extends React.PureComponent<Props> {
    render(): string | null {
        const { earnings } = this.props;

        if (!earnings) {
            return null;
        }
        return toDollars(earnings);
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    earnings: makeSelectMyTimesheetEarnings()
});

export default connect(mapStateToProps)(MyTimesheetEntryEarningsValue);
